import _ from 'lodash'
import fetchBatchProposals from '../request/fetchBatchProposals'
import fetchBatchListings from '../request/fetchBatchListings'
import useOnInit from './useOnInit'
import { COMMA } from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'
import fetchBatch from '../request/fetchBatch'
import { BATCH_PROPOSAL_TYPE } from '../Common/ScheduledBlock'

const useProposalsOnOverviewInit = (props, params, isOverviewPage, beforeInit, afterInit) => {
  const {
    actions
  } = props
  const isScheduleProposal = !_.isEmpty(_.get(params, 'batch.id'))

  useOnInit(() => {
    const getBatchProposalsWithBatch = async (batchParams = {}) => {
      const batchParamsWithField = {
        id: batchParams.id,
        fields: '+details'
      }
      const [batchError, batch = {}] = await fetchBatch(actions, batchParamsWithField)
      if (batchError) {
        afterInit(batchError)
        return
      }

      const isRevertProposal = batchParams.type === BATCH_PROPOSAL_TYPE.REVERT
      const proposalKey = isRevertProposal ? 'revertProposalId' : 'executeProposalId'
      const proposalIds = _.flow(
        () => _.get(batch, 'details', []),
        details => _.map(details, proposalKey),
        _.compact,
        ids => _.join(ids, COMMA)
      )()
      if (_.isEmpty(proposalIds)) {
        afterInit(null, [], [], batch)
        return
      }

      getBatchProposals({ id: proposalIds }, batch)
    }
    const getBatchProposals = async (proposalsParams, batch) => {
      const [proposalsError, batchProposals = []] = await fetchBatchProposals(actions, proposalsParams)
      if (proposalsError) {
        afterInit(proposalsError)
        return
      }

      const listingIds = _.map(batchProposals, 'listing.id')
      const listingIdsStr = _.join(
        _.filter(listingIds, id => !_.isUndefined(id)),
        COMMA
      )
      // 查無提案、查到提案但是沒有賣場
      if (_.isEmpty(listingIdsStr)) {
        afterInit(null, batchProposals, [])
        return
      }

      const listingsParams = {
        id: listingIdsStr,
        ..._.get(params, 'listing', {})
      }

      const [listingsError, batchListings = []] = await fetchBatchListings(actions, listingsParams)
      if (listingsError) {
        afterInit(listingsError)
        return
      }

      // 非預約回檔批次配合 schedule status 資料結構帶入提案執行時間、狀態與永遠立即執行
      const nonScheduleBatch = _.flow(
        () => _.get(batchProposals, '0', {}),
        (batchProposal = {}) => {
          const { executedTs: executeTs, executeStatus } = batchProposal
          return { executeTs, executeStatus, instantExecute: true }
        }
      )()
      const convertedBatch = _.isEmpty(batch) ? nonScheduleBatch : batch
      afterInit(null, batchProposals, batchListings, convertedBatch)
    }
    if (!isOverviewPage) {
      return
    }

    beforeInit && beforeInit()

    if (isScheduleProposal) {
      getBatchProposalsWithBatch(params.batch)
      return
    }

    getBatchProposals(params.proposal)
  })
}

export default useProposalsOnOverviewInit
